import { Arrangement as ArrangementType } from '../../types';
import { assertIsTypeByProperty } from '../../utils/types';
import Arrangement from './Arrangement';
import { SkeletonArrangement, StyledArrangements } from './styles';

interface Props {
	arrangements: Array<ArrangementType | Omit<ArrangementType, 'id'>>;
	isLoading: boolean;
}
export default function Arrangements({ arrangements, isLoading }: Props) {
	return (
		<StyledArrangements>
			{isLoading ? (
				<SkeletonArrangement />
			) : (
				arrangements.map(arrangement => (
					<Arrangement
						arrangement={arrangement}
						key={
							assertIsTypeByProperty<ArrangementType>(arrangement, 'id')
								? arrangement.id
								: 'new'
						}
					/>
				))
			)}
		</StyledArrangements>
	);
}
